import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import AuthCallback from "@/pages/AuthCallback";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Inbox from "@/pages/Inbox";
import Agenda from "@/pages/Agenda";
import CRM from "@/pages/CRM";
import ClientProfile from "@/pages/ClientProfile";
import Settings from "@/pages/Settings";
import Plans from "@/pages/Plans";
import Admin from "@/pages/Admin";
import Landing from "@/pages/Landing";
import Help from "@/pages/Help";
import ConnectShare from "@/pages/ConnectShare";
import Requests from "@/pages/Requests";
import { Toaster } from "@/components/ui/sonner";

function AppRoutes() {
  const location = useLocation();
  // Handle Google OAuth callback fragment before anything else (race-condition safe)
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/planos" element={<Plans />} />
      <Route path="/conectar/:token" element={<ConnectShare />} />
      <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/inbox" element={<Inbox />} />
        <Route path="/agenda" element={<Agenda />} />
        <Route path="/pedidos" element={<Requests />} />
        <Route path="/crm" element={<CRM />} />
        <Route path="/clientes/:id" element={<ClientProfile />} />
        <Route path="/configuracoes" element={<Settings />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/ajuda" element={<Help />} />
      </Route>
      <Route path="/" element={<Landing />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-right" richColors theme="dark" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
